module.exports = __webpack_public_path__ + "img/alarm.9121fcf3.svg";